import Queue from "nq-js";

class AuditUseCase {
  execute(object) {
    return new Queue.Document().create("audit_logs", object);
  }
}

export default AuditUseCase;
